export default "__VITE_ASSET__be53cea1__"